var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SkeletonTheme',{attrs:{"color":"#e3e3e3","highlight":"#c3c3c3"}},[(_vm.showFilter)?[_c('Skeleton',{attrs:{"height":"50px","width":"250px"}})]:_vm._e(),_c('Skeleton',{staticClass:"d-block mt-4 mb-2",attrs:{"height":"25px"}}),_c('div',{staticClass:"line-bottom"}),_c('Skeleton',{staticClass:"d-block mt-4",attrs:{"height":"75px"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }